import { Link } from 'react-router-dom'

import styles from './Notification.module.scss'
import { ReactComponent as SalesMessageIcon } from './salesMessage.svg'

function getMessagingPath(kind) {
  if (kind === 'Service') {
    return 'messaging'
  }

  if (kind === 'Sales') {
    return 'incoming'
  }
}

function getMessagingUIname(kind) {
  if (kind === 'Service') {
    return 'in-property'
  }

  if (kind === 'Sales') {
    return 'sales'
  }
}

const NotificationCard = ({ count, kind, hotelId, handleClick }) => (
  <Link
    to={`/s/${hotelId}/${getMessagingPath(kind)}`}
    className={styles.notification}
    onClick={handleClick}
  >
    <figure className={styles.iconHolder}>
      <SalesMessageIcon />
    </figure>
    <div className={styles.content}>
      <div className={styles.title}>
        {count} pending {getMessagingUIname(kind)} chat{count > 1 ? 's' : ''}
      </div>
      <div className={styles.description}>Click here to see messages</div>
    </div>
  </Link>
)

export default NotificationCard
